'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var NotificationQR = function (_React$Component) {
  _inherits(NotificationQR, _React$Component);

  function NotificationQR() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationQR);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationQR.__proto__ || Object.getPrototypeOf(NotificationQR)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '4', className: 'notification-ribbon__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderImage = function (image) {
      if (image) {
        return _react2.default.createElement('img', { className: 'notification-ribbon__qr', src: image.src, alt: image.alt });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationQR, [{
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          headline = _props$content.headline,
          image = _props$content.image;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        this.renderHeadline(headline),
        this.renderImage(image)
      );
    }
  }]);

  return NotificationQR;
}(_react2.default.Component);

/*
  `config.showMobile` is not used by this molecule,
  however it is read by its parent organisms
*/


exports.default = NotificationQR;
NotificationQR.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }).isRequired
  })
};

NotificationQR.defaultProps = {
  config: {
    type: 'NotificationQR'
  },
  content: {
    headline: {
      text: 'Text introduces CTA or QR code'
    },
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/shared/partnerlogo-ribbon/qr_1.png',
      alt: 'Pre-generated flat file'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/notification-ribbon-qr/jsx/NotificationQR.js
// module id = 670
// module chunks = 4